module.exports = __webpack_public_path__ + "img/9788962602173.ff805cb2.jpg";